import store from '@/store'

class BaseWebSocketSubscriber {
  constructor(socketClient) {
    this.socketClient = socketClient
    this.$store = store
  }
}

export default BaseWebSocketSubscriber
